export default function ItemsGroup({item,section}){
    return(
        <div className="items-collection">
            {item.name}
        </div>
    )
}